import React from 'react'
import { Tag } from 'antd'
import { t } from 'i18next'
import { APPOINTMENT_COLORS } from '../../Common/Color'

export default function AppointmentTypeTag ({ appointment }) {
  let tag = ''
  if (appointment.type === 'PatientAppointment') {
    tag = appointment.specialist ? 'specialist' : 'generalist'
  } else {
    tag = appointment.type
  }
  return <Tag color={APPOINTMENT_COLORS[appointment.type]} variant='solid'>{t(`Admin.Appointment.type.${tag}`)}</Tag>
}
